export default "__VITE_ASSET__X0q9qx$B__"